import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {WorkflowDefinitionControllerService} from '../api/api/workflowDefinitionController.service';

@Injectable({providedIn: 'root'})
export class UserPreferenceService {
  private http = inject(HttpClient);
  private definitionApi = inject(WorkflowDefinitionControllerService);

  private readonly cache = new Map<number, string | null>();

  private get basePath(): string {
    return (this.definitionApi as any).basePath ?? '';
  }

  get(projectId: number): Observable<string | null> {
    if (this.cache.has(projectId)) {
      return of(this.cache.get(projectId) ?? null);
    }
    return this.http.get(`${this.basePath}/users/preferences/${projectId}`, {
      withCredentials: true,
      responseType: 'text',
    }).pipe(
      tap(v => this.cache.set(projectId, v)),
      catchError(() => {
        this.cache.set(projectId, null);
        return of(null);
      }),
    );
  }

  set(projectId: number, value: string): Observable<void> {
    this.cache.set(projectId, value);
    return this.http.put<void>(
      `${this.basePath}/users/preferences/${projectId}`,
      value,
      {withCredentials: true, headers: {'Content-Type': 'application/json'}},
    );
  }
}
